







































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import mainLandPackageList from '@/store/entities/back-mainlandpackage'
    import QRcode from 'qrcodejs2'
    class AddWeight {
        id: number;
        packageId: number;
        cargoCategory: number;
        resultWeight: number;
        long: number;
        wide: number;
        high: number;
        weightImageUploadGuid: string;
        baseSkuNums: number;
        isTrial: boolean;
    }
    @Component
    export default class WeightInput extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        Weight: AddWeight = new AddWeight();
        cargoCategoryType = Enums.CargoCategoryType;
        packageName: string = "";
        selectMainLandPackage: mainLandPackageList = new mainLandPackageList();
        MainLandPackageSelect: Array<mainLandPackageList> = [];
        ShowModelPackage: Array<mainLandPackageList> = [];
        type: number = 0;
        SelectcargoCategory: number = 0;
        MainLandPackage: Array<mainLandPackageList> = [];
        imgUrl: string = "";
        imgUploadUrl: string = '';
        isShow: number;
        result: number = 0;
        loading: boolean = false;
        automaticJump: boolean;
        isfugai: boolean = false;
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };

        async save() {
            (this.$refs.weightForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.Weight.id = this.$store.state.backstockorder.id;
                    this.Weight.isTrial = false;
                    this.automaticJump = this.$store.state.backstockorder.automaticJump;
                    this.loading = true;
                    this.isShow = await this.$store.dispatch({
                        type: 'backstockorder/goodsInfoAdd',
                        data: this.Weight
                    }).finally(() => {
                        this.loading = false;
                    });
                    if (this.isShow > 0) {
                        this.$Modal.confirm({
                            title: "温馨提示", content: "此单已打包，但用户积分不足，不关联本土包裹，提醒用户补充运费后，可勾选此单点击送仓，再管理本土包裹", onOk: async () => {
                                this.get();
                            }
                        });

                        //this.$Message.info("此单已打包，但用户积分不足，不关联本土包裹，提醒用户补充运费后，可勾选此单点击送仓，再管理本土包裹");
                    }
                    this.imgUrl = null;
                    (this.$refs.weightForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                    this.get();
                    document.getElementById('weightqrcode').innerHTML = "";
                    var timestamp1 = (new Date()).valueOf().toString();
                    if (this.automaticJump) {
                        //this.$Modal.success({ title: "打包成功", content: "即将跳转到【快递单号入库页面】！" });
                        this.$router.push({ name: 'intoLogistics', params: { JumpPage: timestamp1 } });
                    }
                    this.get();
                    //this.$store.state.backstockorder.isPacked = true;
                }
            })


        }
        async requestMethod() {
            if (this.Weight.packageId) {
                this.Weight.isTrial = true;
                this.Weight.id = this.$store.state.backstockorder.id;
                if (this.Weight.resultWeight > 0) {
                    this.isShow = await this.$store.dispatch({
                        type: 'backstockorder/goodsInfoAdd',
                        data: this.Weight
                    });
                    this.result = this.isShow;
                }
            }

        }
        async checkgoodsInfo() {
            var n = this.$store.state.backstockorder.tradeNo;
            var modelInfo = await this.$store.dispatch({
                type: 'backstockorder/GetCheckGoodsInfoResult',
                data: { tradeNo: n }
            });
            if (modelInfo == null) {
                this.$Modal.info({
                    title: "提示", content: "未找到此商品信息", onOk: async () => {
                    }
                });
            }
            else {
                if (modelInfo.tradeNo == n) {
                    this.$set(this.Weight, "long", modelInfo.goodsLong);
                    this.$set(this.Weight, "wide", modelInfo.goodsWide);
                    this.$set(this.Weight, "high", modelInfo.goodsHigh);
                    this.$set(this.Weight, "resultWeight", modelInfo.goodsWeight);
                    this.Weight.weightImageUploadGuid = modelInfo.picGuid;
                    this.setImage();
                    setTimeout(() => {
                        this.requestMethod();
                    }, 500);
                }
                else {
                    this.$Modal.confirm({
                        title: "温馨提示", content: "未找到与运单号相匹配的商品信息，但获取到最新的商品信息,运单号【" + modelInfo.tradeNo + "】，是否覆盖？", onOk: async () => {
                            this.$set(this.Weight, "long", modelInfo.goodsLong);
                            this.$set(this.Weight, "wide", modelInfo.goodsWide);
                            this.$set(this.Weight, "high", modelInfo.goodsHigh);
                            this.$set(this.Weight, "resultWeight", modelInfo.goodsWeight);
                            this.Weight.weightImageUploadGuid = modelInfo.picGuid;
                            this.setImage();
                            setTimeout(() => {
                                this.requestMethod();
                            }, 500);
                        }
                    });
                }
            }
        }


        async baseSkuChange(val: any) {

            this.requestMethod();
        }
        async longChange(val: any) {
            this.requestMethod();
        }
        async wideChange(val: any) {
            this.requestMethod();
        }
        async highChange(val: any) {
            this.requestMethod();
        }
        async weightChange(val: any) {
            this.requestMethod();
        }

        updatePackage() {
            this.get();
            (this.$refs.weightForm as any).resetFields();
        }
        async enter() {
            var _this = this;
            if (this.Weight.long == null) {
                //this.$refs[0].['longfocus'][0].focus()
                //this.$nextTick(() => {
                //    this.$refs.longfocus.focus();
                //})
                var data: any = this.$refs.longfocus;
                data.focus();
            }
            else if (this.Weight.wide == null) {
                //this.$refs['widefocus'][0].focus()

                //this.$nextTick(() => {
                //    this.$refs.widefocus[0].focus();
                //})
                var data: any = this.$refs.widefocus;
                data.focus();
            }
            else if (this.Weight.high == null) {
                //this.$refs['highfocus'][0].focus()
                //_this.$refs.highfocus.focus();
                var data: any = this.$refs.highfocus;
                data.focus();
            }
            else if (this.Weight.resultWeight == null) {
                //this.$refs['resultWeightfocus'][0].focus()
                //this.$refs.resultWeightfocus[0].focus();
                var data: any = this.$refs.resultWeightfocus;
                data.focus();
            }

        }
        async cate(val: number) {
            this.MainLandPackageSelect.splice(0, this.MainLandPackageSelect.length);
            if (this.MainLandPackage.length > 0) {
                this.MainLandPackageSelect = this.MainLandPackage.filter(function (item) { return item.cargoCategory == val });
                this.Weight.packageId = this.MainLandPackageSelect[0].id;
                //  this.selectuser.id = this.user[0].id;
            }
        }
        async showmodel() {
            this.MainLandPackageSelect = this.ShowModelPackage;
        }
        handleSuccess(res, file) {
            if (res.success) {
                this.Weight.weightImageUploadGuid = res.result;
                this.setImage();
            }
        }
        handleError(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }
        setImage() {
            if (this.Weight.weightImageUploadGuid && this.Weight.weightImageUploadGuid.length > 1) {
                var data = { imageGuid: this.Weight.weightImageUploadGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.imgUrl = data.url;
            } else {
                this.imgUrl = null;
            }
        }
        setQrCode(val: string) {

            let qrcode = new QRcode('weightqrcode', {
                width: 150,
                height: 150, // 高度
                text: window.location.origin + "/#/takephone/uploadpackageimg?orderNumber=" + val, // 二维码内容
            });
        }
        cancel() {
            (this.$refs.weightForm as any).resetFields();
            this.$emit('input', false);
            document.getElementById('weightqrcode').innerHTML = "";
        }
        validateSequence = (rule, value, callback) => {
            let regNum = /^.{1,5}$/;
            if (value === '') {
                if (rule.field == 'resultWeight') {
                    callback(new Error('不能为空（g）'));
                }
                else {
                    callback(new Error('不能为空（CM）'));
                }

            } else if (!Number.isInteger(+value)) {
                callback(new Error('输入数字'));
            } else if (!regNum.test(value)) {
                callback(new Error('长度过长'));
            } else {
                callback();
            }
        };
        visibleChange(value: boolean) {

            if (!value) {
                this.$emit('input', value);
            } else {
                document.getElementById('weightqrcode').innerHTML = "";
                this.result = 0;
                //this.Weight.baseSkuNums = this.$store.state.backstockorder.BaseSkuNums;
                this.$set(this.Weight, "baseSkuNums", this.$store.state.backstockorder.BaseSkuNums);
                this.Weight.cargoCategory = 0;
                this.cate(0);
                this.Weight.long = 0;
                this.Weight.wide = 0;
                this.Weight.high = 0;
                this.Weight.weightImageUploadGuid = this.$store.state.backstockorder.packimgGuid;
                this.setImage();
                this.setQrCode(this.$store.state.backstockorder.orderNumber);
                setTimeout(() => {
                    var data: any = this.$refs.longfocus;
                    data.focus();
                }, 500);
            }
        }
        async get() {
            this.MainLandPackage.splice(0, this.MainLandPackage.length);
            this.MainLandPackage = await this.$store.dispatch({
                type: 'mainlandpackage/getMainLandPackageList',
                data: {}
            });


        }

        WeightRule = {
            long: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
            wide: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
            high: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
            resultWeight: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
        };

        created() {
            this.get();
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
        }
    }
